import { routeNames } from '@/router/router-constants'
import { useAuthStore } from '@/stores/auth.store'
import { useUserStore } from '@/stores/user.store'
import { useQueryClient } from '@tanstack/vue-query'
import { useRouter } from 'vue-router'

export const useLogout = () => {
  const authStore = useAuthStore()
  const userStore = useUserStore()
  const router = useRouter()
  const queryClient = useQueryClient()

  const logout = () => {
    authStore.logout()
    userStore.resetUser()
    queryClient.invalidateQueries()
    router.push({ name: routeNames.login })
  }

  return logout
}
